import initEmojiPicker from '../utils/emoji-picker';

 (function () {
    'use strict';

    angular.module('canvasModule', ['ngCanvas.dir', 'journey-loader.dir', 'angular.chosen', 'ngCookies'])
        .controller('canvasCon', ['$rootScope', '$scope', '$cookies', '$stateParams', 'canvasService', '$compile', '$timeout', 'helpers','$q', 'AUTH_EVENTS', 'APRO_BME_URL', canvasController]);

    function canvasController($rootScope, $scope, $cookies, $stateParams, canvasService, $compile, $timeout, helpers, $q, AUTH_EVENTS, APRO_BME_URL) {
        // empty the reference
        $rootScope.userEmailAddress = null;
        //Init the green plus icon in false
        $rootScope.activePlus = false;
        // extending translate method, this method not available on isolate scope
        $scope.translate = $rootScope.translate;
        //View Title
        $scope.title = 'Canvas';
        //Set a journey Id for local storage
        $scope.journeyStorageId = 'journey';
        //Loading Type, local storage as default
        $scope.loaderType = 'local';
        //Results of the http call are stored here
        $scope.journeyRes = {};
        //Translate scope
        $scope.translate = $rootScope.translate;
        //Emit jbloader
        $scope.$emit('jbLoader', true);
        //Unsaved data global
        $rootScope.unsavedData = [];
        // Reset rootScope connections
        $rootScope.connections = [];
        // keeps track of the status of the current journey
        $rootScope.currentJourneyStatus = 0;
        // keep track of the segment list page
        $rootScope.segmentListOffset = $rootScope.segmentListOffset || 1;
        // keep track of the list page
        $rootScope.contactListOffset = $rootScope.contactListOffset || 1;
        // keep track of the email page
        $rootScope.emailListOffset = 2;
        // check when to stop loading the list
        $rootScope.stopLoadingList = false;
        //Get the param of the journey
        var journeyId = $stateParams.canvasId;
        // current AP Id
        $rootScope.currentAPId = journeyId;
        // check if smart send is enabled
        $rootScope.isSmartSendingEnabled = false;
        // check if canvas has email node
        $rootScope.canvasHasEmailNode = false;
        // Feature flags
        $rootScope.hasCodeEditor = true;
        $rootScope.hasAproPublish = true;

        $rootScope.isMasterAccount = helpers.readCookie('isMasterAccount') === '1';
        $scope.bmeUrl = APRO_BME_URL;

        // Todo: 'timer' remove this is just to test loading time
        if(console && typeof console.time === 'function') {
            console.time("answer time");
        }

        Intercom('trackEvent', 'AP-LoadsCanvas');

        localStorage.removeItem('journey');

        let templateId = `jbFromDefaultTemplate-${journeyId}`;
        if(journeyId && (localStorage.getItem(templateId) === 'true')) {
            let templateName = localStorage.getItem(`jbFromDefaultTemplateName-${journeyId}`);

            localStorage.removeItem(templateId);
            localStorage.removeItem(templateName);
            $timeout(() => {$rootScope.$emit('coach-register', templateName)}, 500);
        }

        //Check RootScope connection to check if there is only an Entry on the Canvas.
        //We listen the saveJourneyStorage function on Canvas Service.
        $rootScope.$watch('conn', function() {
            if($rootScope.currentJourneyStatus != 3 && $rootScope.currentJourneyStatus != 8 && $rootScope.currentJourneyStatus != 4) {
                if ($rootScope.conn && $rootScope.conn.length === 1 && $rootScope.conn[0].type === 'Entry' ) {
                    $rootScope.activePlus = true;
                }else {
                    $rootScope.activePlus = false;
                }
            }

            let validAp = helpers.isValidJourney();
            // Reuse this watch for emit the event for show arrow connect or delete arrow
            if ($rootScope.conn) {
                for (let i = 0, l = $rootScope.conn.length; i < l; i++) {
                    let connId = $rootScope.conn[i].id || null;

                    if($rootScope.conn[i].type === 'Looping') {
                        if($rootScope.conn[i].hasOwnProperty('children')) {
                            $rootScope.$emit('showConnectionArrow_' + connId, false, connId);
                            $rootScope.$emit('showDeleteArrow_' + connId, true, connId);
                        } else {
                            $rootScope.$emit('showConnectionArrow_' + connId, true, connId);
                            $rootScope.$emit('showDeleteArrow_' + connId, false, connId);
                        }
                    }
                    // get disconnected nodes
                    else if($rootScope.conn[i].hasOwnProperty('children')) {
                        $rootScope.$emit('showConnectionArrow_' + connId, false, connId);
                        $rootScope.$emit('showDeleteArrow_' + connId, true, connId);
                    } else {
                        if(validAp.disconnectedElements.length === 1 &&
                           !$rootScope.conn[i].hasOwnProperty('children') &&
                           validAp.disconnectedElements[0] === $rootScope.conn[i].parent ||
                           (validAp.disconnectedElements.length === 1 && !$rootScope.conn[i].hasOwnProperty('children') && !$rootScope.conn[i].hasOwnProperty('parent') && !$rootScope.conn[i].isRoot) ||
                           (validAp.isValid)
                       ) {
                            $rootScope.$emit('showConnectionArrow_' + connId, false, connId);
                            $rootScope.$emit('showDeleteArrow_' + connId, false, connId);
                        } else {
                            $rootScope.$emit('showConnectionArrow_' + connId, true, connId);
                            $rootScope.$emit('showDeleteArrow_' + connId, false, connId);
                        }
                    }
                }
            }
        });

        if (journeyId && $rootScope.jbToken) {
            $scope.$emit('displayVeil', false);
            //so if the service fails the app does not crashes
            try {
                //Get the journey
                canvasService
                    .getJourney(journeyId)
                    .then(function (result) {
                        _jbCloak();
                        //Set the result data
                        $scope.journeyRes = result.data.JourneyConfiguration;
                        $rootScope.currentJB = JSON.parse(result.data.JourneyConfiguration);
                        // saves current status
                        $rootScope.currentStatus = result.data.Status;
                        //Send the title to the header controller
                        $scope.$emit('journey-title', {name: result.data.JourneyTitle});
                        //Change the canvas loader to grab from service or active journey
                        $scope.loaderType = 'service';
                        //Journey Id
                        $scope.jbId = journeyId;
                        //Set global current status
                        $rootScope.currentJourneyStatus = result.data.Status;
                        // set active days
                        $rootScope.activeDays = helpers.getDayDiff(result.data.ActivatedDate, result.data.LastEditOn);

                        var automationExists = localStorage.getItem('newAutomation' + journeyId) || helpers.readCookie('newAutomation' + journeyId);

                        if(automationExists === 'true') {
                            localStorage.removeItem('newAutomation' + journeyId);
                            $cookies.remove('newAutomation' + journeyId, { domain: 'benchmarkemail.com', path: '/' });
                            $rootScope.$emit('use-template-view');
                        }

                        $scope.fixTopPosCanvas();

                        if (result.data.Status === 3 || result.data.Status === 4 || result.data.Status === 8) {
                            $scope.loaderType = 'active';
                            $rootScope.statusType = 'active';
                            if (result.data.Status === 4) {
                                $scope.$emit('deactivateJourney', true);
                                $scope.$emit('deactivatedJourney', true);
                            } else if (result.data.Status === 8) {
                                $scope.$emit('blockedJourney', true, result.data.LastEditOn);
                            } else {
                                $scope.$emit('activeJourney', true);
                            }
                        }
                        else {
                            $rootScope.statusType = 'draft';
                            $scope.$emit('activeJourney', false);
                        }
                        // clean dom garbage
                        $scope.cleanJourney();
                        $scope.compileLoader();
                        $rootScope.$emit('displayOnboard');

                        var journeyResults = JSON.parse($scope.journeyRes);

                        $scope.journeySegments = $scope._getJourneySegments(journeyResults);
                        if($scope.journeySegments.length){
                            $scope.loadingSegments = true;
                            canvasService
                                .getSegmentsById($scope.journeySegments)
                                .success(function(res) {
                                    res = res.Results;
                                    var segmentData = res.map(function(segment) {
                                        return {
                                            ContactCount: segment.ContactCount,
                                            ListId: segment.ListId,
                                            ListName: segment.ListName,
                                            SegmentId: segment.SegmentId,
                                            SegmentName: segment.SegmentName,
                                            Segmentdescription: ''
                                        }
                                    });
                                    $rootScope.segmentData = $rootScope.segmentData || [];
                                    $rootScope.segmentData = _.reverse(_.uniqBy($rootScope.segmentData.concat(segmentData), 'SegmentId'));
                                })
                                .error(function() {
                                    $rootScope.segmentData = $rootScope.segmentData || [];
                                });
                        }

                        $scope.journeyLists = $scope._getJourneyList(journeyResults);
                        $rootScope.journeyLists = $scope.journeyLists;
                        $rootScope.firstNodejourneyLists = [];
                        $scope.firstNodejourneyLists = $scope._getJourneyFirstNodeList(journeyResults);
                        if($scope.firstNodejourneyLists && ($scope.firstNodejourneyLists != null) && ($scope.firstNodejourneyLists != undefined)) {
                            $rootScope.firstNodejourneyLists = $scope.firstNodejourneyLists;
                        }
                        if($scope.journeyLists.length){
                            $scope.loadingLists = true;
                            canvasService
                                .getLists($scope.journeyLists)
                                .success(function(res) {
                                    var listData = res.map(function(list) {
                                        return {
                                            ContactCount: list.Contactcount,
                                            ListId: list.Id,
                                            ListName: list.Listname
                                        }
                                    });
                                    $rootScope.contactListData = $rootScope.contactListData || [];
                                    $rootScope.contactListData = _.reverse(_.uniqBy($rootScope.contactListData.concat(listData), 'ListId'));
                                    $scope.journeyLists = listData.map(function(list) {
                                      return list.ListId;
                                    });
                                    $rootScope.journeyLists = $scope.journeyLists;
                                })
                                .error(function() {
                                    $rootScope.contactListData = $rootScope.contactListData || [];
                                })
                        }
                    });
            } catch (ex) {
                console.log(ex);
            }
        } else {
            _jbCloak();
            $scope.$emit('jbLoader', false);
            $rootScope.connections = [];
            $timeout(function () {
                $scope.$emit('displayJourney', true);
                $scope.cleanJourney();
                $rootScope.$broadcast('show-box');
            }, 0);
        }

        $scope.fixTopPosCanvas = function() {
            var conns = JSON.parse($scope.journeyRes),
                entry = conns[0];

            if(entry && entry.top < 12020) {
                $('#canvas').css({
                    top: -(entry.top - 40) + 'px'
                });
            }
        };

        $scope.compileLoader = function() {
            // load the journey
            $timeout(function () {
                $compile('<journey-loader></journey-loader>')($scope);
            }, 0);

        };

        $scope._getJourneyList = function (journeyResults) {
            var propsArray = _.map(journeyResults, function (i) {
                    if(i.elemName === 'IfElse') {
                        return i.data.conditionGroups.map(function(i) {
                            if(i.type === 'list') {
                                return i.map(function(test) {return test.selectedOpt})
                            } else {
                                return '';
                            }
                        });
                    } if (i.elemName === 'DateAndTime' || i.elemName === 'AddedToList' || i.elemName === 'AddToList' || i.elemName === 'DeleteContactList' || i.elemName === 'IsOnList') {
                        return i.data.selectedList;
                    } else {
                        return '';
                    }
                });

            return _.uniq(_.compact(_.flattenDeep(propsArray))) || [];
        };

        $scope._getJourneyFirstNodeList = function (journeyResults) {
            var propsArray = [];
            if(journeyResults && journeyResults.length > 0 && journeyResults[0].id) {
                var firstNode = journeyResults[0];
                if(firstNode && firstNode.data && firstNode.data.selectedList && (firstNode != null) && (firstNode != undefined) && (firstNode.data != null) && (firstNode.data != undefined) && (firstNode.data.selectedList != null) && (firstNode.data.selectedList != undefined)) {
                    propsArray = firstNode.data.selectedList || [];
                }
            }

            return _.uniq(_.compact(_.flattenDeep(propsArray))) || [];
        };

        $scope._getJourneySegments = function (journeyResults) {
            var propsArray = _.map(journeyResults, function (i) {
                if (i.elemName === 'IsInSegment' || i.elemName === 'AddedToSegment' || i.elemName === 'DeleteSegmentList' || i.elemName === 'IsNotInSegment') {
                    return i.data.selectedList;
                } else {
                    return '';
                }
            });

            return _.uniq(_.compact(_.flattenDeep(propsArray))) || [];
        };

        $scope._inCurrentSegmentList = function () {
            if(!$rootScope.segmentData) {
                return false;
            }

            var result = $rootScope.segmentData.filter(function (i) {
                    return $scope.journeySegments.indexOf(i.SegmentId) > -1;
                }) || [];

            return result.length === $scope.journeySegments.length && result.length > 0;
        };

        $scope._inCurrentContactList = function () {
            if(!$rootScope.contactListData) {
                return false;
            }

            var result = $rootScope.contactListData.filter(function (i) {
                    return $scope.journeyLists.indexOf(i.ListId) > -1;
                }) || [];

            return result.length === $scope.journeyLists.length && result.length > 0;
        };

        //Line to scroll canvas to top everytime we come from another page inside the JB
        window.scrollTo(0, 0);

        if($( window ).width() < 768) {
            $timeout(() => {
                $scope.mobileMsg = true;
            }, 2000);
        }

        $scope.hideMobileMsg =  () => {
            $scope.mobileMsg = false;
        };

        $scope.cleanJourney = function () {
            $('.canvas ng-init-journey').nextAll().remove();
        };

        function _jbCloak() {
            var cloak = document.getElementById("jbCloak");
            if (cloak) {
                cloak.remove();
            }
            $timeout(function () {
                var css = '.jb-cloak { display:block!important;}',
                    head = document.head || document.getElementsByTagName('head')[0],
                    style = document.createElement('style');

                style.type = 'text/css';
                style.id = 'jbCloak';

                if (style.styleSheet) {
                    style.styleSheet.cssText = css;
                } else {
                    style.appendChild(document.createTextNode(css));
                }

                head.appendChild(style);
            }, 2000);
        }

        $rootScope.isFireFox = navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
        $rootScope.isChrome = /chrom(e|ium)/.test(navigator.userAgent.toLowerCase());
        if(navigator.userAgent.toLowerCase().indexOf('firefox') > -1) {
            document.onkeydown = function checkKey(e) {
                e = e || window.event;
                if(e.keyCode === 9 || e.keyCode === 32 && e.target.localName === 'body') {return false;}
            }
        }

        /*
        * Load Services Section
        * */
        if (!$rootScope.contactListData && !$rootScope.segmentData && journeyId && $rootScope.jbToken) {
            var promiseKeysAsync = ['contactListData', 'segmentData'];
            $rootScope.JBPromisesAsync = [
                    canvasService.getContactList(0, 10) || '',
                    canvasService.getSegments(0,10) || ''
                ] || [];

            $q.all($rootScope.JBPromisesAsync)
                .then(function (res) {
                    var promise;
                    for (var i = 0; i < promiseKeysAsync.length; i++) {
                        promise = promiseKeysAsync[i];
                        if (res[i].data.Results && res[i].data.hasOwnProperty('Results')) {
                            $rootScope[promise] = res[i].data.Results;
                        } else {
                            $rootScope[promise] = [{
                                ListId: "400 Error",
                                ListName: "Opps.. Something went wrong"
                            }];
                        }
                    }
                })
                .catch(function (error, status) {
                    console.log(error, status);
                    if (status === 401) {
                        window.location = AUTH_EVENTS.benchmarkUi;
                    } else if(status >= 500) {
                        Intercom('trackEvent', 'AP-ERROR-404', {
                            description : 'Trigger this event whenever a user will be redirected to 404',
                            metadata: {
                                api: 'contactListData and segmentData api',
                                errStatus: status
                            }
                        });

                        window.location = AUTH_EVENTS.maintenancePage;
                    }
                });
        }

        canvasService.getEmptyEmail().then(({data}) => {
            $rootScope.emptyEmail = data.Response.Data;
        });

        const emojiWrapper = $('.emoji-picker-wrapper');
        initEmojiPicker(emojiWrapper, (syncVal, isPreview) => {
            if(isPreview) {
                $rootScope.$emit('syncEmojiPreviewText', syncVal);
            } else {
                $rootScope.$emit('syncEmoji', syncVal);
            }
        });

        $scope.zIndex = false;
        $rootScope.$on('zIndex', (evt, state) => {
            $scope.zIndex = state;
        });

        let currectCAnvasPos = $('#canvas-container .canvas').position();
        let xCanvasTop  = currectCAnvasPos.top;
        let xCanvasLeft = currectCAnvasPos.left;

        let scale = 1;
        const MAX_SCALE = 1.5;
        const MIN_SCALE = .5;
        $('#selectSlider').slider({
            min: MIN_SCALE,
            value: 1,
            max: MAX_SCALE,
            step: .01,
            slide: (event, ui) => {
                scale = ui.value;
                $('#canvas-container .canvas').css({
                    '-webkit-transform': 'scale(' + scale + ')',
                    '-moz-transform': 'scale(' + scale + ')',
                    '-ms-transform': 'scale(' + scale + ')',
                    '-o-transform': 'scale(' + scale + ')',
                    'transform': 'scale(' + scale + ')'
                });

                $('#zoomFill').css({
                    width: (((MAX_SCALE - scale) - 1) * -100) + '%'
                });
            }
        });

        $scope.recenter = () => {
            scale = 1;
            $('#canvas-container .canvas').css({
                '-webkit-transform': 'scale(' + scale + ')',
                '-moz-transform': 'scale(' + scale + ')',
                '-ms-transform': 'scale(' + scale + ')',
                '-o-transform': 'scale(' + scale + ')',
                'transform': 'scale(' + scale + ')'
            });

            $('#zoomFill').css({
                width: '50%'
            });

            $("#selectSlider").slider('value', 1);

            setTimeout(() => {
                const entryPos = $('.Entry').position();

                currectCAnvasPos = {
                    top: -(entryPos.top - (entryPos.top - 12000)),
                    left: -(entryPos.left - (entryPos.left - 11980))
                };

                $('#canvas').css({ top: currectCAnvasPos.top, left: currectCAnvasPos.left });

                xCanvasLeft = currectCAnvasPos.left;
                xCanvasTop = currectCAnvasPos.top;
            }, 300);
        };

        $scope.zoomOut = () => {
            scale = scale - (scale * .18);

            if (scale > MAX_SCALE) {
                scale = MAX_SCALE;
            }

            if (scale < MIN_SCALE) {
                scale = MIN_SCALE;
            }

            $('#canvas-container .canvas').css({
                '-webkit-transform': 'scale(' + scale + ')',
                '-moz-transform': 'scale(' + scale + ')',
                '-ms-transform': 'scale(' + scale + ')',
                '-o-transform': 'scale(' + scale + ')',
                'transform': 'scale(' + scale + ')'
            });

            $('#zoomFill').css({
                width: (((MAX_SCALE - scale) - 1) * -100) + '%'
            });

            $("#selectSlider").slider('value', scale);
        };

        $scope.zoomIn = () => {
            scale = scale + (scale * .18);

            if (scale > MAX_SCALE) {
                scale = MAX_SCALE;
            }

            if (scale < MIN_SCALE) {
                scale = MIN_SCALE;
            }

            $('#canvas-container .canvas').css({
                '-webkit-transform': 'scale(' + scale + ')',
                '-moz-transform': 'scale(' + scale + ')',
                '-ms-transform': 'scale(' + scale + ')',
                '-o-transform': 'scale(' + scale + ')',
                'transform': 'scale(' + scale + ')'
            });

            $('#zoomFill').css({
                width: (((MAX_SCALE - scale) - 1) * -100) + '%'
            });

            $("#selectSlider").slider('value', scale);
        };

        const canvas = document.getElementById('canvas');
        canvas.onwheel = function (e) {
            e.preventDefault();
           if (e.ctrlKey || e.metaKey) {
               // Your zoom/scale factor
               if (scale <= MAX_SCALE && scale >= MIN_SCALE) {
                   scale -= e.deltaY * 0.01;
               }
               if (scale > MAX_SCALE) {
                   scale = MAX_SCALE;
               }

               if (scale < MIN_SCALE) {
                   scale = MIN_SCALE;
               }

               $("#selectSlider").slider('value', scale);

               $('#zoomFill').css({
                   width: (((MAX_SCALE - scale) - 1) * -100) + '%'
               });

               $('#canvas-container .canvas').css({
                   '-webkit-transform': 'scale(' + scale + ')',
                   '-moz-transform': 'scale(' + scale + ')',
                   '-ms-transform': 'scale(' + scale + ')',
                   '-o-transform': 'scale(' + scale + ')',
                   'transform': 'scale(' + scale + ')'
               });
           } else {
               xCanvasLeft = xCanvasLeft - e.deltaX;
               xCanvasTop = xCanvasTop - e.deltaY;

               $('#canvas').css({ top: xCanvasTop, left: xCanvasLeft });
           }
        };

        const CANVAS_ARROW = 350;
        // register the shortcut handler handler
        document.addEventListener('keyup', function(e) {
            const visibleEl = $('.options-modal').is(':visible');
            const visibleEl2 = $('.modal').is(':visible');

            if (e.target.tagName === 'BODY' && !visibleEl && !visibleEl2) {
                // arrow left
                if(e.keyCode === 37) {
                    xCanvasLeft += CANVAS_ARROW;
                }

                // arrow top
                if(e.keyCode === 38) {
                    xCanvasTop += CANVAS_ARROW;
                }

                // arrow right
                if(e.keyCode === 39) {
                    xCanvasLeft -= CANVAS_ARROW;
                }

                // arrow bottom
                if(e.keyCode === 40) {
                    xCanvasTop -= CANVAS_ARROW;
                }

                $('#canvas').css({
                    top: xCanvasTop,
                    left: xCanvasLeft,
                    transition: 'all .3s ease'
                });

                setTimeout(() => { $('#canvas').css({transition: ''}) }, 400)
            }

            if (e.ctrlKey && e.keyCode == 190) {
                $scope.recenter();
            }
        }, false);

        $scope.instructionsModal = `
            <table class=contactUsageBreakdown-table>
                <thead>
                    <tr>
                        <th colspan=2>${$scope.translate('canvas.zoom.tooltip.1')}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>${$scope.translate('canvas.zoom')}</td>
                        <td><span class=tooltip-button>CTRL</span> + Scroll</td>
                    </tr>
                    <tr>
                        <td>${$scope.translate('canvas.zoom.reset')}</td>
                        <td><span class=tooltip-button>CTRL</span> + <span class=tooltip-button>.</span></td>
                    </tr>
                    <tr>
                        <td>${$scope.translate('canvas.zoom.move')}</td>
                        <td><span class=tooltip-button>&#9664;</span> <span class=tooltip-button>&#9650;</span> <span class=tooltip-button>&#9654;</span> <span class=tooltip-button>&#9660;</span></td>
                    </tr>
                </tbody>
            </table>
            <span class=instructions-text>${$scope.translate('canvas.zoom.tooltip.2')}</span>`;

        canvasService
            .getSmartSendingInfo()
            .success(function ({ Response }) {
                $rootScope.isSmartSendingEnabled = Response.Data.SSEnabled === '1'
            });

        helpers.getFeatureFlags().then((response) => {
            const hasCodeEditor = response.data.data['code-editor'];
            const hasAproPublish = response.data.data['apro-publish'];
            $rootScope.hasCodeEditor = assignValue(hasCodeEditor, true);
            $rootScope.hasAproPublish = assignValue(hasAproPublish, true);
        }).finally(() => $rootScope.$emit('featureFlagsLoaded', true));

        function assignValue(value, defaultValue) {
          if (typeof value === 'undefined') {
            return defaultValue;
          }

          return value;
        }
    }
})();


// WEBPACK FOOTER //
// ./app/controllers/canvasController.js